export default __webpack_public_path__ + "static/ai-powered-min-053939332a78737d6b196a46263a3aa1.png";